import { API_BASE_URL, Role } from '../constants.js';
import { auth, fb } from '../firebase/config.js';
import { 
  APIError,
  LoginError
} from '../errors/app-errors.js';
import { 
  residents,
  accounts,
  user,
  alertFilters } from '../store.js';
import { AppController } from '../AppController';
import { push } from 'svelte-spa-router';

export const LoginService = {

  signIn: async (username, password) => {
    const response = await fetch(`${API_BASE_URL}/authorize`, {
      method: 'POST',
      body: JSON.stringify({
        username,
        password
      })
    });

    const data = await response.json();

    if (response.status === 200) {
      // TODO remove persistent auth I think
      await auth.setPersistence(fb.auth.Auth.Persistence.LOCAL);
      await auth.signInWithCustomToken(data.token);
      const { role }  = await (await auth.currentUser.getIdTokenResult()).claims;
      const user = Object.assign({}, {...data, role});
      AppController.setUser(user);
      // TODO add if admin, push to customers
      if (user.role === Role.ADMIN) {
        push('/admin/accounts')
      } else {
        push('/app/alert');
      }
    } else if(response.status === 404) {
      throw new LoginError(data.message);
    } else {
      throw new APIError(data.message);
    }
  },

  signOut: async (username, password) => {
    await auth.signOut();
    residents.set([]);
    accounts.set([]);
    user.set({});
    alertFilters.set([]);
    if(username, password) {
      push(`/login/${username}/${password}`)
    } else {
      push('/login');
    }
  },

  reset: async (email) => {
    try {
      const response = await fetch(`${API_BASE_URL}/reset`, {
        method: 'POST',
        body: JSON.stringify({
          email
        })
      });

      if(response.status < 200 || response.status > 300) {
        throw new Error(response);
      }

      return response;
    } catch (err) {
      throw new Error(err);
    }
  }
}